import MinMessage from '../../components/molecules/messages/MinMessage'
export default {
  components: { MinMessage }
}
